import React from 'react';
import { Check, MapPin } from 'lucide-react';
import centralImage from '../assets/about-image.jpg';
import bennettImage from '../assets/bennett-valley.jpg';

export default function About() {
  return (
    <section id="about" className="py-20 bg-surface">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {/* Images */}
          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/5] group">
                <img 
                  src={centralImage} 
                  alt="Central Cleaners" 
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-300"></div>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/5] group">
                <img 
                  src={bennettImage} 
                  alt="Bennett Valley Dry Cleaners" 
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-300"></div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 space-y-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Premium Care You Can Trust
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              At Central Cleaners & Bennett Valley Dry Cleaners, we provide expert garment care with attention to detail, fabric-safe cleaning methods, and a personal touch. With two convenient Santa Rosa locations, we make professional dry cleaning easy and reliable.
            </p>
            
            <div className="flex items-center gap-2 text-brand-dark font-medium text-lg">
              <MapPin size={20} />
              <span>Two convenient locations in Santa Rosa.</span>
            </div>

            <div className="space-y-4 pt-2">
              {[
                "Detail-focused garment care",
                "Safe cleaning for delicate fabrics",
                "Expert pressing & finishing",
                "Trusted local service"
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="mt-1 w-5 h-5 rounded-full bg-brand/20 flex items-center justify-center flex-shrink-0">
                    <Check size={12} className="text-brand-dark" />
                  </div>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
